export default "__VITE_ASSET__hOOP50cq__"